import { Component, OnInit, Inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-view-case-note',
  templateUrl: './view-case-note.component.html',
  styleUrls: ['./view-case-note.component.scss']
})
export class ViewCaseNoteComponent implements OnInit {

  @Input() caseNoteObj: any;
  
  noteText: string = "";
  byUserName: string = "";
  dateCreated: string = "";

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    if(this.caseNoteObj != null) {
      this.noteText = this.caseNoteObj.notes;
      this.byUserName = this.caseNoteObj.addedBy.firstName + " " + this.caseNoteObj.addedBy.lastName;
      this.dateCreated = this.caseNoteObj.addedDateTime;
    }
  }

}
